module.exports = __webpack_public_path__ + "media/images/svg/quotation-a25cd3e49a668758f9121348b42cd015.svg";